import type { AccessProfileFiltersFormProps } from './types'

export const initialFormValues: AccessProfileFiltersFormProps = {
  userId: '',
  profileDescription: 'Todos',
  profileType: 'Todos',
  status: 'Todos'
}
